import { CompanyFormState } from "company/detail/components/models";
import { Status } from "components";
import UserWithAvatar from "components/Atoms/UserWithAvatar";
import { MergeFormSection } from "components/MainSectionTemplate/types";
import TagList from "components/Tag/TagList";
import React from "react";

export const generalDetailsSection = (
  existingCompany: CompanyFormState,
  existingTags: server.dto.TagSmall[],
  sourceCompany: CompanyFormState,
  sourceTags: server.dto.TagSmall[],
  currentCompany: CompanyFormState,
  currentTags: server.dto.TagSmall[],
  setCurrentCompany: (company: CompanyFormState) => void,
  setCurrentTags: (tags: server.dto.TagSmall[]) => void
): MergeFormSection => ({
  key: "generalDetails",
  title: RESX.GeneralLabels.GeneralDetails,
  fields: [{
    key: "status",
    label: RESX.Status.resxStatus,
    currentValue: currentCompany.status,
    existingValue: existingCompany.status,
    sourceValue: sourceCompany.status,
    isEmpty: () => false,
    render: (value: server.dto.Status) => <Status status={value} />,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      status: sourceCompany.status,
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      status: existingCompany.status,
    }),
  }, {
    key: "tags",
    label: RESX.Tag.Tags,
    currentValue: currentTags,
    existingValue: existingTags,
    sourceValue: sourceTags,
    isEmpty: (v) => v.length === 0,
    render: (value: server.dto.TagSmall[]) => <TagList tags={value} length="short" />,
    onSourceClick: () => setCurrentTags(sourceTags),
    onExistingClick: () => setCurrentTags(existingTags),
  }, {
    key: "owner",
    label: RESX.GeneralLabels.Owner,
    currentValue: currentCompany.owner,
    existingValue: existingCompany.owner,
    sourceValue: sourceCompany.owner,
    isEmpty: () => false,
    render: (value: server.dto.UserSmall) => <UserWithAvatar user={value} />,
    onSourceClick: () => setCurrentCompany({
      ...currentCompany,
      owner: sourceCompany.owner,
    }),
    onExistingClick: () => setCurrentCompany({
      ...currentCompany,
      owner: existingCompany.owner,
    }),
  }]
})